import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import { saveUnwindBlockValuesToDatabase } from "@/services/ActionSummaryTableSERVICES";
import tradeBlockDataStore, {
  ItradeBlockData,
} from "@/store/tradeBlockDataStore";

import tradeDataStore from "@/store/tradeDataStore";
import tradeSettingsStore from "@/store/tradeSettingsStore";
import {
  isBlockDisabledForNPV,
  isBlockDisabledForRecoupon,
  isTwoWayQuoteType,
} from "./UnwindHeaderCheckboxHelpers";

function returnThisBlock(
  currentTradeBlockData: ItradeBlockData[],
  esid: string,
  id: number,
) {
  const theseBlocks = currentTradeBlockData.find(
    (blocks) => blocks.esid == esid, //fullTradeData.esid,
  );

  const thisBlock = theseBlocks?.blocks?.find(
    (block) => block.id == id, //params.data.id,
  );

  return thisBlock;
}

const ReCouponAndNPVCheckboxCellRenderer = (params: any) => {
  const { getAccessTokenSilently } = useAuth0();
  const fullTradeData: ExecutionStrategy = params.fullTradeData;

  const currentTradeBlockData = tradeBlockDataStore(
    (state) => state.tradeBlockData,
  );

  const [thisBlock, setThisBlock] = useState(
    returnThisBlock(currentTradeBlockData, fullTradeData.esid, params.data.id),
  );

  useEffect(() => {
    setThisBlock(
      returnThisBlock(
        currentTradeBlockData,
        fullTradeData.esid,
        params.data.id,
      ),
    );
  }, [currentTradeBlockData]);

  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade = currentTradeData.find(
    (trade) => trade.esid == fullTradeData.esid,
  );

  const field = params.colDef.field;
  const isNPV = field == "npv";
  const isReCoupon = field == "recoupon";

  const [unwindValue, setUnwindValue] = useState<"NPV" | "Recoupon" | null>();
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  // const [status, setStatus] = useState<ExecutionStrategyStatus>(
  //   params.fullTradeData.status,
  // );

  useEffect(() => {
    if (thisBlock) {
      setUnwindValue(thisBlock.unwind);
    }
  }, []);

  useEffect(() => {
    if (thisBlock) {
      setUnwindValue(thisBlock.unwind);
    }
  }, [thisBlock]);

  const allTradeSettings = tradeSettingsStore(
    (state) => state.tradeSettingsData,
  );
  const thisTradeSettings = allTradeSettings.find(
    (t) => t.esid === thisTrade?.esid,
  )?.settings;

  // LQC-2370: shared helpers keep this cell in lockstep with the header
  // checkbox (UnwindHeaderCheckbox), including the per-CP Two-Way guard.
  useEffect(() => {
    if (!thisTrade || !thisBlock) {
      return;
    }
    const status = thisTrade.status as ExecutionStrategyStatus; // only OP = always ExecutionStrategyStatus
    const isTwoWay = isTwoWayQuoteType(thisTradeSettings, thisTrade);
    setIsDisabled(
      isNPV
        ? isBlockDisabledForNPV(thisBlock, status, isTwoWay)
        : isBlockDisabledForRecoupon(thisBlock, status),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [thisTrade, thisBlock, allTradeSettings]);

  useEffect(() => {
    if (unwindValue && field) {
      if (
        (isNPV && unwindValue == "NPV") ||
        (isReCoupon && unwindValue == "Recoupon")
      ) {
        setIsChecked(true);
      } else if (
        (isNPV && unwindValue != "NPV") ||
        (isReCoupon && unwindValue != "Recoupon")
      ) {
        setIsChecked(false);
      } else {
        setIsChecked(false);
      }
    } else {
      setIsChecked(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unwindValue]);

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    await saveUnwindBlockValuesToDatabase(
      params,
      fullTradeData,
      getAccessTokenSilently,
      field,
      event.target.checked,
    );
  };

  if (params.data.instrumentType == "SWP") {
    return (
      <div className="ag-labeled ag-label-align-right ag-checkbox ag-input-field">
        <div
          className={`ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper  ${isChecked ? "ag-checked" : ""} ${isDisabled ? "ag-disabled" : ""}`}
        >
          <input
            type="checkbox"
            className="ag-cell-wrapper ag-checkbox-cell"
            checked={isChecked}
            onChange={handleChange}
            disabled={isDisabled}
          />
        </div>
      </div>
    );
  } else return <div></div>;
};

export default ReCouponAndNPVCheckboxCellRenderer;
